import React, { useState, useEffect } from 'react'
import { Input } from 'antd'
import type { InputProps } from 'antd'

type CustomInputNumberProps = InputProps
const CustomInputNumber = (props: CustomInputNumberProps) => {
  const { onChange, value, ...rest } = props
  const [inputVal, setInputVal] = useState(value)

  useEffect(() => {
    setInputVal(value)
  }, [value])

  const customOnChange = (e) => {
    const val = e.target.value
    let formatNum = null
    if (val?.length === 1 && /[^0-9]/gi.test(val)) {
      formatNum = null
    } else if (!!val || val === '0') {
      formatNum = parseInt(e.target.value.replace(/[^0-9]/gi, ''))
    }
    setInputVal(formatNum)
    onChange(formatNum)
  }
  return <Input {...rest} value={inputVal} onChange={customOnChange}></Input>
}

export default CustomInputNumber
